(() => {
  if (window.wrenHeroSliderContainedLoaded) return;
  window.wrenHeroSliderContainedLoaded = true;

  const instances = new Map();
  const selector = '[data-module="hero-slider-contained"]';

  function initialize(el) {
    if (instances.has(el) || !window.wrenCreateContainedHeroSlider) return;

    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const button = el.querySelector('[data-hero-autoplay-toggle]');
    const enabled = el.dataset.autoplay === 'true' && Number(el.dataset.slideCount) > 1;
    const slider = window.wrenCreateContainedHeroSlider(el);
    let paused = motion.matches;
    let hovered = false;
    let focused = false;

    function sync() {
      if (enabled && !paused && !hovered && !focused && !document.hidden) {
        slider.play(5000);
      } else {
        slider.pause();
      }
      if (button) {
        button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      }
    }

    function toggle() { paused = !paused; sync(); }
    function enter() { hovered = true; sync(); }
    function leave() { hovered = false; sync(); }
    function focusIn() { focused = true; sync(); }
    function focusOut(event) { focused = el.contains(event.relatedTarget); sync(); }
    function motionChange() { paused = motion.matches; sync(); }

    el.addEventListener('mouseenter', enter);
    el.addEventListener('mouseleave', leave);
    el.addEventListener('focusin', focusIn);
    el.addEventListener('focusout', focusOut);
    button?.addEventListener('click', toggle);
    motion.addEventListener('change', motionChange);
    document.addEventListener('visibilitychange', sync);

    instances.set(el, () => {
      slider.destroy();
      el.removeEventListener('mouseenter', enter);
      el.removeEventListener('mouseleave', leave);
      el.removeEventListener('focusin', focusIn);
      el.removeEventListener('focusout', focusOut);
      button?.removeEventListener('click', toggle);
      motion.removeEventListener('change', motionChange);
      document.removeEventListener('visibilitychange', sync);
      instances.delete(el);
    });

    sync();
  }

  function initializeWithin(root) {
    root.querySelectorAll(selector).forEach(initialize);
  }

  document.addEventListener('wren:contained-hero-ready', () => initializeWithin(document));
  document.addEventListener('DOMContentLoaded', () => initializeWithin(document));
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((destroy, el) => {
      if (event.target.contains(el)) destroy();
    });
  });

  initializeWithin(document);
})();
